class RequestError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LocalLogicTracking/RequestError";
  }
}

export { RequestError };
